module.exports = __webpack_public_path__ + "img/img_50@2x.b3d69bdb.png";